var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopFooterWave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1632,
    height: 386,
    viewBox: "0 0 1632 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1632,
    height: 386,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.86 65.6578C813.072 62.5612 820.371 59.559 827.758 56.6518C1091.67 -47.2643 1397.17 -3.30972 1631.91 148.332V388L-2.78048 391.798L-9.34601e-05 148.332C8.28039 144.534 16.746 140.929 25.3938 137.526C121.794 99.5849 226.854 92.4465 327.228 111.334C492.599 142.453 660.639 127.98 805.86 65.6578Z",
    fill: "url(#paint0_linear_201_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_4",
    x1: -8.07523e-8,
    y1: 74.166,
    x2: 1631.91,
    y2: 74.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1632,
    height: 386,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopFooterWave);
export default __webpack_public_path__ + "static/media/desktop-footer-wave.b0048e495212b1fe6e5a10ab6764ac47.svg";
export { ForwardRef as ReactComponent };